
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
   //   this.cart = document.querySelector('#right-drawer-slot') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
    //  if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
    
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
     // this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
    /*  if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }*/
      
      const cartData = {};

      //TODO: Decide what triggers this conditional; should these products ALWAYS be sent as bundles (for future updating by the customer?)
      const is_bundle = formData.get('is_bundle');
      
      if(is_bundle == "true" && this.form.dataset.byoProductId) {
        const bundleProductData = {
          productId: this.form.dataset.byoProductId, //set in block settings, passed through the form
          variantId: this.form.dataset.byoVariantId, //set in block settings, passed through the form
          sellingPlan: 688741024025, //default; below map from user selection formData.get('selling_plan')
          handle: this.form.dataset.byoHandle, //set in block settings, passed through the form
        }
      
        //bundleProductData.sellingPlan = this.mapSellingPlan(bundleProductData.productId, formData.get('selling_plan'));
        
        const bundle = {
          "externalVariantId": bundleProductData.variantId,
          "externalProductId": bundleProductData.productId,
          "selections": [
            {
              "collectionId": this.form.dataset.byoBaseCollectionId,
              "externalProductId": this.form.dataset.productId,
              "externalVariantId": formData.get('id'),
              "quantity": formData.get('quantity'),
              "sellingPlan": formData.get('selling_plan'),
            }
          ]
        };
        const customizations = this.form.querySelectorAll('input[name="customizations[]"]');
        customizations.forEach((customization) => {
          bundle.selections.push({
            "collectionId": customization.dataset.collectionId,
            "externalProductId": customization.dataset.productId,
            "externalVariantId": customization.value,
            "quantity": formData.get('quantity'),
            "sellingPlan": this.mapSellingPlan(customization.dataset.productId, formData.get('selling_plan'))
          });
        });


        const cartItems = recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
        console.log("cartItems",cartItems);
        if(formData.get('properties[Mix Name]')) {
          cartItems[0].properties.Mix_Name = formData.get('properties[Mix Name]');
        }
        
        //if the bundle can't be built, tell the user why here, but recharge seems to build the bundle no matter what
        //shopify's error messaging for not available and sold out is then parsed on add to cart as expected
        //we WILL hide out of stock and unavailable add-ons in the UI

        //assign items generated for the bundle
        cartData.items = cartItems;
        
        //remove unnecessary form data here (should be removed from HTML?)
        formData.delete('quantity');
        //MUST remove these, or an extra product is added alongside the bundle
        formData.delete('selling_plan');
        formData.delete('id');

      } 
      
      //add the formdata to the object; needed to use application/json to pass multiple products simultaneously
      for (const [key, value] of formData) {
        cartData[key] = value;
      }
      console.log("cartData",cartData);
      config.body = JSON.stringify(cartData);
      config.headers['Content-Type'] = 'application/json';

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
               
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
           document.dispatchEvent(new Event('cart:updated')); 
         // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          
        });
    }

    mapSellingPlan(bundle_product_id, user_selected_selling_plan_id) {
      if(selling_plans_map[this.form.dataset.productId]) {
        const delivery_every = selling_plans_map[this.form.dataset.productId][user_selected_selling_plan_id];
        if(delivery_every) {
          for (const key in selling_plans_map[bundle_product_id]) {
            const value = selling_plans_map[bundle_product_id][key];
            if(value) {
              if(value.toLowerCase() == delivery_every.toLowerCase()) {
                return key;
              }
            }
          }
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}








